import api from '../../api'

export default {

    namespaced: true,



    state: {
        loading: true,
        userInfo: null,
        changed: false,

        /** флаг, означающий то, что был совершен переход на settings2, и при возвращении назад с этой страницы можно пытаться "сохранить" настройки */
        entered: false
    },

    getters: {},

    mutations: {
    
        SET_LOADING(state, value) {
            state.loading = value
        },

        SET_USER_INFO(state, userInfo) {
            state.userInfo = userInfo
/*             state.changed = false */
        },

        SET_SETTING(state, { settingName, newValue }) {
            state.userInfo.settings[settingName] = newValue
            state.changed = true
        },

        SET_EMAIL(state, newEmail) {
            state.userInfo.contacts.email = newEmail
            state.changed = true
        },

        SET_PHONE(state, newPhone) {
            /** Условие на случай, если телефон меняется "не из настроек" */
            if (state.userInfo) {
                state.userInfo.contacts.phone = newPhone
                state.changed = true
            }
        },

        SET_ENTERED(state, value) {
            state.entered = value
        }

    },
    actions: {

        DELETE_EMAIL({commit}) {


            return api.emailDelete()
            .then( res => {

                commit("SET_EMAIL", '')

            })

        },

/*         CONFIRM_PHONE({commit}, {phone, confirmCode}) {
            return api.phoneConfirm(confirmCode)
            .then( res => {
                commit("SET_PHONE", phone)
            })
        }, */

/*         CONFIRM_EMAIL({commit}, confirmCode) {

            return api.emailConfirm(confirmCode)
            .then( res => {
                commit("SET_EMAIL", email)
               
            })
        }, */
      
        FETCH({commit}) {
            commit("SET_LOADING", true)
            return api.getUserInfo()
            .then( userInfo => {
                commit('SET_USER_INFO', userInfo)
            })
            .finally(()=> {
                commit("SET_LOADING", false)
            })
        },
    
        SET_SETTING({ commit }, { settingName, newValue }) {
            return api.setSettings({[settingName]: newValue})
            .then( res => {
                commit("SET_SETTING", arguments[1]) 
            })
        }
    } 
}